import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

/**
 * Convertr Form component
 * @param {string} formSlug - formSlug reference from Convertr campaign
 * @param {string} whitepaperId - whitepaperId from Convertr campaign
 * @param {string} publisherId - publisherId from Convertr campaign
 * @param {string} locale - locale number from whitepaper Convertr campgain
 * @param {string} formId - unique form ID; only required if more than 1 forms on page; generated by FE
 * @param {boolean} loadStyles - Whether to apply the class names for styling
 * @param {Object} extraClassNames - Extra class names to be applied to the component
 * @param {Object} context - Extra information coming from Polaris provider.
 */

const ConvertrForm = (
  {
    formSlug,
    whitepaperId,
    publisherId,
    locale,
    formId,
    loadStyles,
    extraClassNames,
    context: { cssPrefix },
  },
) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = `https://dennis.cvtr.io/forms/${formSlug}/serve.js?wp=${whitepaperId}&locale=${locale}&p=${publisherId}`;
    script.async = true;
    script.type = 'text/javascript';
    script.id = `serveCvtrForm-${formSlug}`;
    script.dataset.target = `convertr-form-${formId}`;
    script.dataset.css = 'false';

    document.body.appendChild(script);

    return () => {
      try {
        document.body.removeChild(script);
      } catch (e) {
        console.error(e);
      }
    };
  }, [formSlug, locale, whitepaperId]);
  return (
    <div
      id={`convertr-form-${formId}`}
      className={classNames({
        [`${cssPrefix}__convertr-form`]: loadStyles,
        ...extraClassNames,
      })}
    />
  );
};

ConvertrForm.propTypes = {
  formSlug: PropTypes.string,
  whitepaperId: PropTypes.string,
  publisherId: PropTypes.string,
  locale: PropTypes.string,
  loadStyles: PropTypes.bool,
  formId: PropTypes.string,
  extraClassNames: PropTypes.objectOf(PropTypes.bool),
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
};

ConvertrForm.defaultProps = {
  formSlug: '',
  whitepaperId: '',
  publisherId: '',
  locale: '',
  formId: 'convertr1',
  loadStyles: true,
  extraClassNames: {},
  context: {},
};

export default withPolaris(ConvertrForm);
